module.exports = __webpack_public_path__ + "img/sec6desk.07ba2ee1.png";